module.exports = __webpack_public_path__ + "static/media/bv.b41a8d75.svg";